import Layout from "@/ui/legacy/layout";

export default function BabyStaking() {
  return (
    <Layout>
      <div className="h-[500px]">Baby staking</div>
    </Layout>
  );
}
